import { Link } from "@amzn/awsui-components-react";
import { Stage } from "../../../lusca-search-api/generated-src";
import { devUserQuery } from "../../../helpers/devUser";

export interface OrderItem {
  orderId: string;
  stage: Stage;
  user?: string;
}

export const COLUMN_DEFINITIONS = [
  {
    id: "orderId",
    header: "Order ID",
    width: 350,
    cell: (item: OrderItem) => (
      <Link
        href={`/?stage=${encodeURIComponent(item.stage)}${devUserQuery(
          item.user
        )}&transactionId=${encodeURIComponent(item.orderId)}`}
        external
      >
        {item.orderId}
      </Link>
    ),
    sortingField: "orderId",
  },
  {
    id: "stage",
    header: "Stage",
    width: 100,
    cell: (item: OrderItem) => item.stage,
    sortingField: "stage",
  },
];
